import React from "react";

export function CheckboxButton({ text, emoji, selected, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`
        w-full p-4 rounded-2xl transition-all duration-200
        flex items-center justify-between border-2
        ${
          selected
            ? "bg-green-50 border-green-500"
            : "bg-white border-gray-200 text-gray-700"
        }
      `}
    >
      <div className="flex items-center gap-4 text-left">
        {emoji && <span className="text-2xl">{emoji}</span>}
        <span className="font-medium whitespace-normal">{text}</span>
      </div>
      <div
        className={`w-6 h-6 rounded-md border-2 flex items-center justify-center transition-all duration-200
          ${
            selected
              ? "bg-green-500 border-green-500"
              : "border-gray-300 bg-white"
          }
        `}
      >
        {selected && (
          <svg
            className="w-4 h-4 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={4}
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </div>
    </button>
  );
}
